/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */

// @mui material components
import { Grid, Modal } from "@mui/material";
import Card from "@mui/material/Card";
import { Box } from "@mui/system";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Billing page components
import Bill from "layouts/billing/components/Bill";
import { useState } from "react";
import './style.css'

function BillingInformation() {
  const [open,setOpen]=useState(true);
  const handleOpen=()=>{
    setOpen(true);
  }
  return (
    <Card id="delete-account">
      <Grid className="project-header" container >
      <Grid xs={12} md={6} lg={6} >
        <MDTypography variant="h6" fontWeight="medium">
          Project Information
        </MDTypography>
      </Grid>
      <Grid xs={12} md={6} lg={6} >
      {/* <div>
        {<button type="button" id="project-btn" className="" onClick={() => setOpenAccount(!openAccount)}>Add</button>}
        <Modal

          open={open}
          onClose={() => setOpen(!open)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box>
            p
          </Box>
          
        </Modal>
        </div> */}
      </Grid>
      </Grid>
      <MDBox pt={1} pb={2} px={2}>
        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          <Bill 
            name="oliver liam"
            company="viking burrito"
            email="oliver@burrito.com"
            vat="FRB1235476"
          />
          <Bill
            name="lucas harper"
            company="stone tech zone"
            email="lucas@stone-tech.com"
            vat="FRB1235476"
          />
          <Bill
            name="ethan james"
            company="fiber notion"
            email="ethan@fiber.com"
            vat="FRB1235476"
            noGutter
          />
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default BillingInformation;
